<ngx-smart-modal
  [identifier]="identifier()"
  [customClass]="customClass()"
  [hideDelay]="hideDelay()"
  [refocus]="false"
  #modal
>
  @if (modal.visible) {
    <ng-container
      [ngTemplateOutlet]="dialogTemplate()"
      [ngTemplateOutletContext]="{$implicit: modal.getData(), modal: modal}"
    >
    </ng-container>
  }
</ngx-smart-modal>
